import React from 'react';
import {
    Route, Switch
} from 'react-router-dom';

import {
    Header, LeftNav
} from '../../app';
import ContentRoute from '../content/content-route';
import { ROUTES } from '../index';
import LandingRoute from '../landing/landing-route';
import { WelcomeRoute } from '../welcome/welcome-route';
import { HBox } from './dashboard.styled';

/**
 * Main route which manages left navigation and all module routes.
 */
export const DashboardRoute = () => {
    return (
        <>
            <Header />
            <HBox>
                <LeftNav />
                <Switch>
                    <Route
                        path={ROUTES.welcome}
                        component={WelcomeRoute}
                    />
                    <Route
                        path={ROUTES.contentByModuleId}
                        component={ContentRoute}
                    />
                    <Route
                        path={ROUTES.landingByGroupId}
                        component={LandingRoute}
                    />
                </Switch>
            </HBox>
        </>
    );
};
